import React, { Component } from "react"
import PorfolioBlock from "../components/PortfolioBlock"

import Badge from "../components/Badge";
import certificates from "../data/certifications";


class Index extends Component {
    render() {
    return (
    <main className="page landing-page">
        <PorfolioBlock>
            <p>Cybersecurity Analyst | Digital Forensics • Vulnerability Assessment • Security Engineering</p>
            <p>Hello! I am <strong>Daniel Vasquez</strong>, a cybersecurity-focused technologist and operations leader with experience in digital forensics, vulnerability analysis, and secure systems design. I develop security-focused projects using tools such as Autopsy, Wireshark, Nmap, and React-based data systems while continuing to expand my expertise in security monitoring, risk assessment, and network defense.</p>
            <p>Alongside my cybersecurity work, I lead large-scale restaurant operations where I design risk-reduction programs, incident reporting workflows, and operational analytics initiatives that strengthen compliance, access control, and organizational reliability. I have completed my M.S. in Cybersecurity and Information Assurance from Western Governors University (WGU) and continue building hands-on security and software development projects.</p>
            <p>M.S. Cybersecurity & Information Assurance (WGU) • Security+ • CySA+ • PenTest+ • SSCP</p>
            <p>Thank you for taking the time to explore my portfolio.</p>
        </PorfolioBlock>
        <div className="social-icons">
            <h2>Skills</h2>
            <hr />
            <figure className="figure"><i className="fas fa-shield-alt"></i>
                <figcaption className="figure-caption">Network Security</figcaption>
            </figure>
            <figure className="figure"><i className="fas fa-bug"></i>
                <figcaption className="figure-caption">Vulnerability Assessment</figcaption>
            </figure>
            <figure className="figure"><i className="fas fa-search"></i>
                <figcaption className="figure-caption">Digital Forensics</figcaption>
            </figure>
            <figure className="figure"><i className="fas fa-network-wired"></i>
                <figcaption className="figure-caption">Wireshark & Network Analysis</figcaption>
            </figure>
            <figure className="figure"><i className="fas fa-terminal"></i>
                <figcaption className="figure-caption">Linux Security</figcaption>
            </figure>
            <figure className="figure"><i className="fas fa-user-shield"></i>
                <figcaption className="figure-caption">Incident Response</figcaption>
            </figure>
            <figure className="figure"><i className="fas fa-database"></i>
                <figcaption className="figure-caption">SIEM & Log Analysis</figcaption>
            </figure>
            <figure className="figure"><i className="fas fa-cloud"></i>
                <figcaption className="figure-caption">Cloud Security</figcaption>
            </figure>
            <figure className="figure"><i className="fas fa-code"></i>
                <figcaption className="figure-caption">Python & Security Scripting</figcaption>
            </figure>
        </div>

        <div className="social-icons">
            <h2>Certifications</h2>
            <hr />
            {certificates.map((badge, index) => (
                <Badge key={index} {...badge} />
            ))}
        </div>
        <br />
        {/* <div data-aos="fade" className="simple-slider">
            <div className="swiper-container">
                <div className="swiper-wrapper">
                    <div className="swiper-slide" style={{backgroundImage: "url(assets/img/nature/forrest.png)"}}></div>
                    <div className="swiper-slide" style={{backgroundImage: "url(assets/img/nature/santa%20cruz.jpg)"}}></div>
                    <div className="swiper-slide" style={{backgroundImage: "url(assets/img/nature/sunset.jpg)"}}></div>
                </div>
                <div className="swiper-pagination"></div>
                <div className="swiper-button-prev"></div>
                <div className="swiper-button-next"></div>
            </div>
        </div> */}
    </main>
);
}}

export default Index;
